import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ProgressBar } from "@/components/common";
import { useEvaluation } from "./EvaluatorApp";
import { EvaluatorHeader, JobButton } from "./EvaluatorHeader";
import { CandidateBoard } from "./CandidateBoard";

export default function WorkspacePage() {
  const { ctx, token } = useEvaluation();
  const nav = useNavigate();
  const allDone = ctx.progress.total > 0 && ctx.progress.evaluated === ctx.progress.total;
  return (
    <div className="min-h-screen">
      <EvaluatorHeader right={<JobButton />} />
      <main className="fade-up mx-auto max-w-4xl px-4 py-10 sm:px-6">
        <div className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="eyebrow mb-2">Adaylar</p>
            <h1 className="font-heading text-2xl font-bold tracking-tight sm:text-3xl">{ctx.job.title}</h1>
            <p className="mt-2 text-sm text-plena-text2">Her adayın CV'sini inceleyip 12 kategoriye göre puanlayın ve genel uygunluk puanı verin. Yanıtlarınız otomatik kaydedilir.</p>
          </div>
          <div className="w-full sm:w-56">
            <p className="mb-1.5 text-right text-sm text-plena-text2" data-testid="workspace-progress">{ctx.progress.evaluated} / {ctx.progress.total} aday değerlendirildi</p>
            <ProgressBar value={ctx.progress.evaluated} total={ctx.progress.total} tone="bg-plena-success" />
          </div>
        </div>
        {!ctx.category_ranking_complete && (
          <div className="mb-6 flex flex-col gap-3 rounded-2xl bg-[#FDF4DC] px-6 py-5 sm:flex-row sm:items-center sm:justify-between" data-testid="priority-incomplete-banner">
            <div><p className="font-medium text-[#8A6414]">Kategori önceliklendirmesi tamamlanmadı</p><p className="text-sm text-[#8A6414]">Adayları değerlendirmeden önce bu pozisyon için kategorileri sıralayın.</p></div>
            <Button variant="outline" data-testid="go-priorities-button" onClick={() => nav(`/e/${token}/priorities`)} className="rounded-full bg-white">Kategorileri Önceliklendir</Button>
          </div>
        )}
        {ctx.candidates.length === 0 ? <p className="plena-card px-6 py-10 text-sm text-plena-text2" data-testid="no-candidates">Bu değerlendirmede henüz aday bulunmuyor.</p> : <CandidateBoard />}
        <div className="mt-10 flex flex-col items-start gap-3 rounded-2xl bg-white px-6 py-6 ring-1 ring-plena-border sm:flex-row sm:items-center sm:justify-between">
          <div>
            <p className="font-heading font-semibold">{allDone ? "Tüm adaylar değerlendirildi" : "Sıralama adımı"}</p>
            <p className="text-sm text-plena-text2">{allDone ? "Şimdi adayları genel değerlendirmenize göre sıralayabilirsiniz." : `Sıralamaya geçmek için kalan ${ctx.progress.total - ctx.progress.evaluated} adayı değerlendirin.`}</p>
          </div>
          <Button data-testid="go-ranking-button" disabled={!allDone || !ctx.category_ranking_complete} onClick={() => nav(`/e/${token}/ranking`)} className="btn-press rounded-full">Adayları Sırala <ArrowRight className="ml-1.5 h-4 w-4" /></Button>
        </div>
      </main>
    </div>
  );
}
